import { Columns } from '@app/components/simple-table/simple-table.component';

export const assignEmployeesProjectTableColumns: Columns[] = [
    { columnName: 'time-tracking.indexProjectsPage.assignedEmployeesTable.name', columnSpan: 'columns-6' },
    { columnName: 'time-tracking.indexProjectsPage.assignedEmployeesTable.dateAssigned', columnSpan: 'columns-5' },
];
